import { Routes } from './Routes';
import 'bootstrap/dist/css/bootstrap.min.css';
import './fonts.css';
import './container.css';

export const App = () => {
    return (
        <div>
            <Routes />
        </div>
    );
}
